export default function formatJurisdictions(jurisdictions) {
  return jurisdictions?.map(j => ({ key: j.countryCodeAlpha, value: j.isoJurisdictionName })) ?? [];
}

export function jurisdictionIgaModel(countryCodeAlpha, jurisdictions) {
  if (jurisdictions === null) {
    return undefined;
  }
  return jurisdictions.find(j => j.countryCodeAlpha === countryCodeAlpha)?.igaModel;
}
